module.exports = __webpack_public_path__ + "static/media/admission.cd2ce6d5.jpg";